class CountUpNumber extends HTMLElement {
  connectedCallback() {
    this.end = parseFloat(this.dataset.end);
    if (Number.isNaN(this.end)) return;

    this.start = parseFloat(this.dataset.start) || 0;
    this.duration = parseInt(this.dataset.duration, 10) || 1500;
    this.decimals = (String(this.dataset.end).split('.')[1] || '').length;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.render(this.end);
      return;
    }

    this.render(this.start);

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.observer.disconnect();
          this.animate();
        });
      },
      { threshold: 0.4 }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  animate() {
    const startedAt = performance.now();
    const delta = this.end - this.start;

    const step = (now) => {
      const progress = Math.min((now - startedAt) / this.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);

      this.render(this.start + delta * eased);

      if (progress < 1) {
        this.frame = requestAnimationFrame(step);
      } else {
        this.render(this.end);
      }
    };

    this.frame = requestAnimationFrame(step);
  }

  render(value) {
    this.textContent = value.toFixed(this.decimals);
  }
}

if (!customElements.get('count-up-number')) {
  customElements.define('count-up-number', CountUpNumber);
}
